import { Fragment, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import Dialog from '@rio-cloud/rio-uikit/Dialog';
import { CLOSE_DIALOG_EVENT } from '@rio-cloud/rio-uikit/FrameDialog';
import usePostMessageSender from '@rio-cloud/rio-uikit/usePostMessageSender';

import { CRITICAL, LOW_MILEAGE, NO_DATA, OK, WARNING } from '@/features/batteryOverview/utils/BatteryDataUtils';
import { BatteryPack } from '@/generated/GeneratedApiTypes';
import SoHValue from './SoHValue';

const BATTERY_SERVICE_DIALOGS = 'BATTERY-SERVICE-DIALOGS';

const getSoHStatusClass = (status: string | undefined) => {
    switch (status) {
        case OK:
            return 'primary';
        case WARNING:
            return 'warning';
        case CRITICAL:
            return 'danger';
        default:
            return '';
    }
};

const getStatusColumnSize = (status: string | undefined) => {
    if (status === NO_DATA || status === LOW_MILEAGE) return '3';
    else return '4';
};

export const PackLevelDetailsDialog = ({ batteryPackLevel }: { batteryPackLevel: BatteryPack[] }) => {
    const { sendMessageToParent } = usePostMessageSender();

    const handleCloseDialog = useCallback(() => {
        sendMessageToParent({
            type: `${BATTERY_SERVICE_DIALOGS}${CLOSE_DIALOG_EVENT}`,
            payload: `Closed Pack Level dialog}`,
        });
    }, [sendMessageToParent]);

    return (
        <>
            <div
                className="display-flex justify-content-between align-items-center padding-15"
                style={{ borderBottom: '1px solid var(--10)' }}
            >
                <span className="text-size-h4">
                    <FormattedMessage id="intl-msg:batteryService.batteryPackLevel.details" />
                </span>
                <button
                    type="button"
                    className="btn btn-icon-only btn-muted close"
                    onClick={handleCloseDialog}
                    aria-label="dialog close button"
                >
                    <span className="rioglyph rioglyph-remove" aria-hidden="true" />
                </button>
            </div>
            <Dialog.Body className={'padding-15'}>
                {batteryPackLevel.map(({ id, state_of_health_percentage, state_of_health_status }) => (
                    <Fragment key={id}>
                        <div className="margin-bottom-10">
                            <FormattedMessage id="intl-msg:batteryService.batteryPackLevel.pack" /> &nbsp;
                            {id}
                        </div>
                        <div className="list-group margin-bottom-15 padding-left-10">
                            <div
                                className={`list-group-item list-group-item-${getSoHStatusClass(state_of_health_status)} rounded-none display-flex row text-size-12`}
                            >
                                <div
                                    className={`text-color-darkest col-${getStatusColumnSize(state_of_health_status)}`}
                                >
                                    <FormattedMessage id="intl-msg:batteryService.batteryPackLevel.packSoH" />
                                </div>
                                <SoHValue
                                    status={state_of_health_status ?? ''}
                                    percentage={state_of_health_percentage}
                                    textSize={12}
                                    valueClassName="text-color-darkest"
                                />
                            </div>
                        </div>
                    </Fragment>
                ))}
            </Dialog.Body>
        </>
    );
};
